// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDIsHE82vW4eG2Wf1Mpu634FMF31nkA6VE",
  authDomain: "sanjeetpathak-299d2.firebaseapp.com",
  databaseURL: "https://sanjeetpathak-299d2-default-rtdb.firebaseio.com",
  projectId: "sanjeetpathak-299d2",
  storageBucket: "sanjeetpathak-299d2.firebasestorage.app",
  messagingSenderId: "831833719717",
  appId: "1:831833719717:web:b4fe1cdf5740aeca341e4c",
  measurementId: "G-11WJM8HKQX"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const database = getDatabase(app);

export { database };
